/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, ObservableMap } from '@stencil/store';
import { loadingHelper } from './loading-helper';
import { Job } from './models/job';
import { PicklistItem } from './models/picklistItem';
// import { globalTrackingService } from "./services/globaltracking.service";

// eslint-disable-next-line no-var
export var baseStore: ObservableMap<any>;

export function initStore<T extends { [key: string]: any }>(data: T) {
    baseStore = createStore<T>(data);

    loadingHelper.state.subscribe(({ loading, topLoadingId }) => {
        baseStore.state.loading = loading;
        baseStore.state.loadingId = topLoadingId;
    });
}
export interface IBasicStore {
    loading: boolean;
    loadingId?: string;
    error: any;
    errorId?: string;
    job?: Job;
    pickListData?: { [key: string]: PicklistItem[] };
    hideLoading: boolean;
}
